import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Common } from '../models/Common';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  checkValidation = "Don't Check Validation";

  constructor(public toastController: ToastController) { }

  async presentToast(message: string, time?: number) {
    if (time == null) {
      time = 3000
    }
    const toast = await this.toastController.create({
      message,
      duration: time,
      position: 'top',
      animated: true,
    });
    await toast.present();
  }

  async error(message: string, time?: number, header?: string) {
    if (time == null) {
      time = 3000
    }
    const toast = await this.toastController.create({
      message,
      duration: time,
      position: 'top',
      animated: true,
      color: 'danger',
      header: header
    });
    await toast.present();
  }

  async warning(message: string, time?: number, header?: string) {
    if (time == null) {
      time = 3000
    }
    const toast = await this.toastController.create({
      message,
      duration: time,
      position: 'top',
      animated: true,
      color: 'warning',
      header: header
    });
    await toast.present();
  }

  async success(message: string, time?: number, header?: string) {
    if (time == null) {
      time = 3000
    }
    const toast = await this.toastController.create({
      message,
      duration: time,
      position: 'top',
      animated: true,
      color: 'success',
      header: header
    });
    await toast.present();
  }

  validation(object: Common): Promise<boolean> {
    return new Promise(resolve => {
      this.checkValidation = "Check Validation";
      // console.log("start Checking", new Date());
      setTimeout(async () => {
        this.checkValidation = "Don't Check Validation";
        let found = false;
        if (object.pageValidation != null) {
          // console.log(object);
          object.pageValidation.forEach(value => {
            if (value.length > 0) {
              found = true;
            }
          })
        }
      // console.log(found)
        // console.log("end Checking", new Date(), object.pageValidation);
        if (!found) {
          object.pageValidation = null;
          resolve(true);
        } else {
          let message = "";
          // console.log(object.pageValidation)
          object.pageValidation.forEach(async (value) => {
            for (let msg of value) {
              message = msg;
              const toast = await this.toastController.create({
                message,
                header: "Validation Error",
                duration: 3000,
                position: 'top',
                animated: true,
                color: 'warning',
              });
              toast.present();
            }
          });
          // console.log(message);
          resolve(false);
        }
      }, 500);
    })
  }
}
